import config from "environment";
import { getRequest, postRequest, putRequest, deleteRequest } from "./client";
import {
  CreateCompanyContract,
  UpdateCompanyContract,
  Company,
  CheckBackedAPIResponse,
} from "winslow-core";
const { baseApi } = config;

export async function apiGetCompany(
  id: string
): Promise<Company | null> {
  const fetchURL = `${baseApi}/companies/${id}`;
  return await getRequest(fetchURL, "API/apiGetCompany");
}

export async function apiGetCompanyByWorkspaceId(
  workspaceId: string
): Promise<Company | null> {
  const fetchURL = `${baseApi}/companies/workspace/${workspaceId}`;
  return await getRequest(fetchURL, "API/apiGetCompanyByWorkspaceId");
}

export async function apiCreateCompany(
  payload: CreateCompanyContract["Body"]
): Promise<CheckBackedAPIResponse<Company>> {
  const fetchURL = `${baseApi}/companies/create`;
  return await postRequest(fetchURL, payload, "API/apiCreateCompany");
}

export async function apiUpdateCompany(
  id: string,
  payload: UpdateCompanyContract["Body"]
): Promise<Company | null> {
  const fetchURL = `${baseApi}/companies/${id}`;
  return await putRequest(fetchURL, payload, "API/apiUpdateCompany");
}

export async function apiDeleteCompany(
  id: string
): Promise<Company | null> {
  const fetchURL = `${baseApi}/companies/${id}`;
  return await deleteRequest(fetchURL, "API/apiDeleteCompany");
}

export async function apiUpdateCompanyAsOnboarded(id: string): Promise<Company | null> {
  const fetchURL = `${baseApi}/companies/${id}/onboarded`;
  return await getRequest(fetchURL, "API/apiUpdateCompanyAsOnboarded");
}

